import {toThousands} from '../../util/util'
export default {
  data() {
    return {
      formData: null,
      selections: '',
      excel_url: '/sfdrdownload/',
      pdf_url: '/sfdrdownload/',
    }
  },
  methods: {
    cellClickEvent({row, column}) {
      // Coverage列切换至Coverage组件
      if (column.property === "coverage") {
        var data = new Object()
        data.data_point = row.data_point
        data.metrics = row.metrics
        data.units = row.units
        data.indicators = row.indicators
        this.$router.push({path: '/sfdrcoverage', query: {data: data}})
      }
    },
    // 动态切换组件
    changeComponent() {
      this.$router.push('/sfdrupload')
    },
    // 合并单元格
    mergeRowMethod ({row, _rowIndex, column, visibleData}) {
      const fields = column.title.toLowerCase()
      let cellValue = row[fields]
      if (fields == 'indicators') {
        let prevRow = visibleData[_rowIndex - 1]
        let nextRow = visibleData[_rowIndex + 1]
        if (prevRow && prevRow[fields] === cellValue) {
          return {rowspan: 0, colspan: 0}
        } else {
          let countRowspan = 1
          while (nextRow && nextRow[fields] === cellValue) {
            nextRow = visibleData[++countRowspan + _rowIndex]
          }
          if (countRowspan > 1) {
            return {rowspan: countRowspan, colspan: 1}
          }
        }
      }
    },
    // 下载pdf文件
    printPdf() {
      const {
        href
      } = this.$router.resolve({ path:  '/pdffile', query: {} })
      window.open(href,'_blank')
    }
  },
  created () {
    this.selections = JSON.parse(window.sessionStorage.getItem('sfdr'))
    if (this.selections) this.formData = JSON.parse(this.selections.report)
  },
  watch: {
    selections: function (){
      this.formData = JSON.parse(this.selections.report)
      this.excel_url = '/sfdrdownload/' + this.selections.excel
      this.pdf_url = '/sfdrdownload/' + this.selections.pdf
    }
  },
  computed: {
    current_AUM: function () {
      let temp = this.selections.aum_reporting_date.toFixed(2)
      let b = temp.toString().split('.')
      let numbers = toThousands(b[0]) + '.' + toThousands(b[1])
      return this.selections.aum_reporting_date_currency?this.selections.aum_reporting_date_currency + ' ' + numbers : ''
    },
    last_AUM: function () {
      let temp = this.selections.aum_last_reporting_date.toFixed(2)
      let b = temp.toString().split('.')
      let numbers = toThousands(b[0]) + '.' + toThousands(b[1])
      return this.selections.aum_last_reporting_date_currency?this.selections.aum_last_reporting_date_currency + ' ' + numbers : ''
    },
    tableColumn() {
      return [
        {title: this.$t('sfdr.indicators'),
          field: 'indicators',
          type: 'html',
          width: 200,
          className: 'report_column_title',
          formatter: ({cellValue})=>{
            let indicator = cellValue.substring(3, cellValue.length)
            let img = cellValue.substring(0, 2).split('.')[0]
            let src = "../../../static/images/sfdr_icon/" + img +  ".png"
            return  `<img src="${src}"  style="height: 40px" />` + `<div style="display: inline">` + indicator + `</div>`
          }},
        {title: this.$t('sfdr.metrics'), field: "metrics",width: 300},
        // {title: "Units", field: "units", width: 100},
        {title: this.$t('sfdr.description'),
          field: "description",
          width: 500,
          formatter: ({cellValue, row})=>{
            if (row.units) return 'unit: ' + row.units + '\n' + (cellValue ? cellValue : '')
            else return cellValue
          }},
        {title: this.$t('sfdr.coverage'),
          field: "coverage",
          width: "160",
          type: 'html',
          className: 'report-point',
          formatter: ({ cellValue, row })=>{
          // return Number(cellValue).toFixed(1) + '%'
          let end = row.note ? '*' : ''
          return cellValue?(cellValue*100).toFixed(2) + '%' + end +`<i class="vxe-icon--arrow-right report-right-arrow"></i>`:cellValue
        }},
        {title: 'Value',
          width: 270,
          field: "value_of_report_date",
          headerClassName: 'value-first-column',
          className: 'value-first-column',
          formatter:({ cellValue, row ,column })=>{
            if (this.selections.report_date) {
              if (typeof this.selections.report_date=='string')
                column.title = 'Value[' + this.selections.report_date + ']'
            }
            // return cellValue.toFixed(2)
            if(cellValue==1||cellValue==0) return cellValue
            return cellValue?cellValue.toFixed(2): cellValue
          }},
        {title: 'Value',
          width: 270,
          headerClassName: 'value-second-column',
          className: 'value-second-column',
          field: "value_of_last_report_date",
          formatter:({ cellValue, row, column })=>{
            if (this.selections.report_date) {
              if (typeof this.selections.report_date == 'string')
                column.title = 'Value[' + this.selections.last_report_date + ']'
            }
            // return cellValue.toFixed(2)
            if(cellValue==1||cellValue==0) return cellValue
            return cellValue?cellValue.toFixed(2): cellValue
          }},
        {title: this.$t('sfdr.delta'),
          field: "delta",
          className: ({row, rowIndex, column})=>{
            if (row.delta) {
              if(row.delta<0){
                let key = row.indicators.split('.')[0]
                if(key=='13'||key =='11') {
                  return 'report-delta-red'
                } else {
                  return 'report-delta-green'
                }
              } else {
                let key = row.indicators.split('.')[0]
                if (key =='13'|| key == '11'){
                  return 'report-delta-green'
                } else {
                  return 'report-delta-red'
                }
              }
            }
            return 'report-delta-green'
          },
          formatter: ({cellValue}) => {
            return cellValue?(cellValue*100).toFixed(2) + '%':'-'
          }
        }
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/sfdr/js/sfdr_report.js